import React from 'react';

const EnvTest = () => {
  const envVars = {
    'REACT_APP_SUPABASE_URL': process.env.REACT_APP_SUPABASE_URL,
    'REACT_APP_SUPABASE_ANON_KEY': process.env.REACT_APP_SUPABASE_ANON_KEY ? '*** (exists)' : 'Not found',
    'NODE_ENV': process.env.NODE_ENV,
    'PUBLIC_URL': process.env.PUBLIC_URL
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h2>Environment Variables</h2>
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Variable</th>
            <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(envVars).map(([key, value]) => (
            <tr key={key}>
              <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{key}</td>
              <td style={{ 
                borderBottom: '1px solid #ddd', 
                padding: '8px',
                color: value && value !== 'Not found' ? 'green' : 'red',
                fontWeight: value && value !== 'Not found' ? 'normal' : 'bold'
              }}>
                {value || 'Not set'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EnvTest;
